export default (function () {
    const customRadio = {
        init() {
            $(document).on('change', 'input[type="radio"]',function () {
                $('.custom_radio--active').removeClass('custom_radio--active');
                $(this).closest('.custom_radio').addClass('custom_radio--active');
            });
        },
    };
    $(document).ready(() => {
        customRadio.init();
    });
}());
